import type { IconNode } from '../types';

/**
 * @name toolbox
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCA3VjVhMiAyIDAgMCAxIDItMmg0YTIgMiAwIDAgMSAyIDJ2MiIgLz4KICA8cGF0aCBkPSJNOCAyMWEyIDIgMCAwIDAgMi0ydi04YTQgNCAwIDAgMC04IDB2OGEyIDIgMCAwIDAgMiAyaDE2YTIgMiAwIDAgMCAyLTJ2LThhNCA0IDAgMCAwLTQtNEg2IiAvPgogIDxwYXRoIGQ9Ik0yIDEzaDIwIiAvPgogIDxwYXRoIGQ9Ik0xNCAxNXYtNCIgLz4KICA8cGF0aCBkPSJNMTggMTV2LTQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/toolbox
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const toolbox: IconNode = [
  ['path', { d: 'M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2', key: 'gxrri' }],
  [
    'path',
    {
      d: 'M8 21a2 2 0 0 0 2-2v-8a4 4 0 0 0-8 0v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a4 4 0 0 0-4-4H6',
      key: '1usafx',
    },
  ],
  ['path', { d: 'M2 13h20', key: '5evz65' }],
  ['path', { d: 'M14 15v-4', key: '5ovjyx' }],
  ['path', { d: 'M18 15v-4', key: 'qktd5h' }],
];

export default toolbox;
